module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-affiliazioni"
  }, [_c('div', {
    staticClass: "row"
  }, [(false) ? _c('div', {
    staticClass: "col s3"
  }, [_c('el-form-item', [_c('el-input', {
    model: {
      value: (_vm.affiliazione.id),
      callback: function($$v) {
        _vm.$set(_vm.affiliazione, "id", $$v)
      },
      expression: "affiliazione.id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s10"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.affiliazione
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.affiliazione.nome),
      callback: function($$v) {
        _vm.$set(_vm.affiliazione, "nome", $$v)
      },
      expression: "affiliazione.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [(_vm.affiliazione.id == -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.aggiungi,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.affiliazione.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.salvamodifiche,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "edit"
    },
    on: {
      "click": _vm.editNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.affiliazione.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.cancella,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete"
    },
    on: {
      "click": _vm.delNow
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('div', {
    staticClass: "row pad help"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.affiliazioniOrderHelp)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "list": _vm.$teras.affiliazioni
    },
    on: {
      "end": _vm.onEnd
    }
  }, _vm._l((_vm.$teras.affiliazioni), function(element, index) {
    return _c('div', {
      key: element.id,
      on: {
        "click": function($event) {
          return _vm.onEdit(element)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + " " + _vm._s(element.nome))])
  }), 0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ecc24ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-affiliazioni.vue
// module id = 608
// module chunks = 2